import {h} from "preact";
import {GlobalsContext} from "../AppContext";
import {useContext, useState} from "preact/hooks";
import style from './offer-button.css';
import clsx from "clsx";

interface OwnProps {
    icon?: string;
    title?: string;
}

const OfferButton = ({ title, icon}: OwnProps) => {
    const { setWidgetOpen, widgetOpen } = useContext(GlobalsContext);
    const [hovered, setHovered] = useState(false);

    return (
        <div className={clsx(style.root,{[style.hover] : hovered && title})}
             onMouseLeave={()=>setHovered(false)}
             onMouseEnter={()=>setHovered(true)}
             onClick={() => setWidgetOpen(!widgetOpen)}>
            <img class={clsx(style.icon)} src="https://fastfine.ru/themes/yellow/assets/img/icons/popup_subs_grey.svg"/>
            {hovered && title && <span className={clsx(style.text)}>{title}</span>}
        </div>
    );
};

export default OfferButton;
